(function(){
  Number.prototype.format = function(n, x) {
      var re = '\\d(?=(\\d{' + (x || 3) + '})+' + (n > 0 ? '\\.' : '$') + ')';
      return this.toFixed(Math.max(0, ~~n)).replace(new RegExp(re, 'g'), '$&,');
  }


  function updateTotal(){
    var totalCart = 0

    $('.item-row').each(function(){
      var quantity = $(this).find('input.quantity').val()
      var price = $(this).find('.cart-price').text()
      totalCart += quantity * (price/100)
    })
    $('.cart-total-price').text('$ ' + totalCart.format(2))
  }

  $('.btn-up').on('click', function(){
    var id = $(this).data('id')
    var quantity = $('.row-' + id).find('input.quantity').val()
    var price = $('.row-' + id).find('.cart-price').text()

    quantity++
    var total = ((price * quantity)/100).format(2)

    $('.row-' + id).find('.cart-total').text('$' + total)
    $('.row-' + id).find('.cart-quantity').text('x ' + quantity)
    $('.row-' + id).find('input.quantity').attr('value',quantity)
    updateTotal()
  })

  $('.btn-down').on('click', function(){
    var id = $(this).data('id')
    var quantity = $('.row-' + id).find('input.quantity').val()
    var price = $('.row-' + id).find('.cart-price').text()

    if (quantity > 1) {
      quantity--
      var total = ((price * quantity)/100).format(2)

      $('.row-' + id).find('.cart-total').text('$' + total)
      $('.row-' + id).find('.cart-quantity').text('x ' + quantity)
      $('.row-' + id).find('input.quantity').attr('value',quantity)
      updateTotal()
    }
  })

})()
